import { Modal, Button as Btn } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { useTranslation } from "contexts/TranslationContext";

// "Installment details" application picker — shown when the user clicks the
// Installment Details card in Settings, listing their SIGNED V2 applications.
// Continue navigates to the dashboard with the chosen application's id.
const InstallmentSelectModal = ({
  open,
  apps,
  selectedAppId,
  onSelect,
  onCancel,
  onContinue,
}) => {
  const { translate } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable
      closeIcon={<CloseOutlined style={{ fontSize: "16px", color: "#000" }} />}
      centered
      width={560}
      destroyOnClose
    >
      <div className="pt-2 pb-1">
        <h2 className="text-xl md:text-2xl font-bold text-[#1F1F1F] mb-1">
          {translate("SETTINGS.INSTALLMENT_DASHBOARD")}
        </h2>
        <p className="text-[#8E9196] text-sm mb-5">
          {translate("SETTINGS.SELECT_ONE_APPLICATION")}
        </p>

        <div className="flex flex-col gap-3 max-h-[320px] overflow-y-auto pr-1">
          {apps.map((app) => {
            const active = selectedAppId === app.APPLID;
            return (
              <button
                key={app.APPLID}
                type="button"
                onClick={() => onSelect(app.APPLID)}
                className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-start transition-colors ${
                  active
                    ? "border-primary bg-[#F4FAFB]"
                    : "border-[#E0E0E0] bg-white hover:border-primary"
                }`}
              >
                <span
                  className={`w-5 h-5 rounded-full border flex items-center justify-center shrink-0 ${
                    active ? "border-primary" : "border-[#C8CDD2]"
                  }`}
                >
                  {active ? (
                    <span className="w-2.5 h-2.5 rounded-full bg-primary" />
                  ) : null}
                </span>
                <span className="text-[#1F1F1F] text-sm md:text-base">
                  {translate("SETTINGS.APPLICATION_ID")}: {app.APPLID}
                </span>
              </button>
            );
          })}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Btn
            className="rounded-full bg-[#F0F0F0] text-[#2F2F2F] font-semibold px-8 py-5 border-0"
            onClick={onCancel}
          >
            {translate("CREATE_REQUEST.CANCEL")}
          </Btn>
          <Btn
            disabled={!selectedAppId}
            className="rounded-full bg-primary text-white font-semibold px-8 py-5 border border-primary disabled:opacity-60 hover:!border-primary hover:border-solid hover:!text-primary"
            onClick={onContinue}
          >
            {translate("OTHER_SERVICES.CONTINUE")}
          </Btn>
        </div>
      </div>
    </Modal>
  );
};

export default InstallmentSelectModal;
